
import BaseService from './BaseService';
import entities from 'src/config/entities';
import axios from "axios/index";
import format from 'date-fns/format'
import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'
import FileService from 'src/services/FileService'

class OrderService extends BaseService {


  constructor() {
    super({ entity: entities.ORDER });
  }

  async orderVerify(orderId, data) {
    try {
      return await axios.put(`orders/${orderId}/verify`, data)
    } catch (e) {
      this._handleError({ translationKey: 'generic.update.error', error: e });
      throw e;
    }
  }

  async updateOrderPrice(orderId, data) {
    try {
      return await axios.put(`orders/${orderId}/price`, data)
    } catch (e) {
      this._handleError({ translationKey: 'generic.update.error', error: e });
      throw e;
    }
  }


  async export(data, extension) {
    try {
      let res = await axios.post(`orders/export/${extension}/`, data, {
        responseType: 'blob'
      })

      let fileName = `orders-${format(new Date(), FRIENDLY_DATETIME_FORMAT)}.${extension}`
      FileService.downloadFileInBrowser(res, fileName)
    } catch (e) {
      this._handleError({ translationKey: 'order.messages.exportError', error: e });
      throw e;
    }
  }
}

export default new OrderService();
